(() => {
  const init = () => {
    const rail = document.querySelector('.dm-home .product-rail');
    const collection = rail?.closest('.dm-home');
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const updateRail = () => {
      if (!rail) return;
      collection.querySelector('[data-prev]').disabled = rail.scrollLeft < 4;
      collection.querySelector('[data-next]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    if (rail && !rail.dataset.ready) {
      rail.dataset.ready = 'true';
      rail.addEventListener('scroll', updateRail, {passive:true});
      new ResizeObserver(updateRail).observe(rail);
      collection.querySelectorAll('[data-prev],[data-next]').forEach(button => button.addEventListener('click', () => {
        const card = rail.querySelector('.product-card:not([hidden])');
        rail.scrollBy({left:(button.hasAttribute('data-prev')?-1:1)*((card?.offsetWidth||280)+18),behavior:motion()});
      }));
      updateRail();
    }
    document.querySelectorAll('.dm-home [data-filter]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const need = button.getAttribute('aria-pressed') === 'true' ? 'Wszystkie' : button.dataset.filter;
        document.querySelectorAll('.dm-home .need-buttons [data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.filter === need)));
        const cards = [...rail.querySelectorAll('.product-card')];
        cards.forEach(card => {card.hidden = need !== 'Wszystkie' && card.dataset.need !== need;});
        const count = cards.filter(card => !card.hidden).length;
        collection.querySelector('.product-count').textContent = `${count} ${count===1?collection.dataset.one:count<5?collection.dataset.few:collection.dataset.many}`;
        collection.querySelector('.filter-reset').hidden = need === 'Wszystkie';
        rail.scrollLeft=0;updateRail();
        document.querySelector('#produkty').scrollIntoView({behavior:motion(),block:'start'});
      });
    });
    document.querySelectorAll('.dm-home [role="tablist"]').forEach(list => {
      if (list.dataset.ready) return;
      list.dataset.ready='true';
      const section=list.closest('.dm-home');
      const tabs=[...list.querySelectorAll('[role="tab"]')];
      const select=(tab,scrollToPanel=false)=>{
        tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1;t.querySelector('.formula-tab-action path').setAttribute('d',selected?'M12 4v16m-6-6 6 6 6-6':'M5 19 19 5M5 5h14v14');});
        section.querySelectorAll('[role="tabpanel"]').forEach(panel=>{panel.hidden=panel.id!==tab.getAttribute('aria-controls');});
        if(scrollToPanel&&matchMedia('(max-width:700px)').matches){
          requestAnimationFrame(()=>document.getElementById(tab.getAttribute('aria-controls'))?.scrollIntoView({behavior:motion(),block:'start'}));
        }
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>select(tab,true));
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight') next=(index+1)%tabs.length;
          if(event.key==='ArrowLeft') next=(index-1+tabs.length)%tabs.length;
          if(event.key==='Home') next=0;
          if(event.key==='End') next=tabs.length-1;
          if(next!==undefined){event.preventDefault();select(tabs[next]);tabs[next].focus();}
        });
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
